import React, { useEffect, useState } from 'react';
import { Tree } from 'antd';
import { useTranslation } from 'react-i18next';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import { CollapseBlock } from '../../../../../common';
import { SubmitButton } from '../../../../../common/form/FormElements';
import { SortItemRenderer } from '../../../../../common';
import useOnTreeDrop from '../../../../../../hooks/useOnTreeDrop';

const copyObject = (obj) => JSON.parse(JSON.stringify(obj));

const simplifyHierarchy = (data, parentId = null) => {
  return data.map((section, index) => {
    const children = section.children
      ? simplifyHierarchy(section.children, section.id)
      : [];
    return {
      id: section.id,
      order: index,
      parent_id: parentId,
      children,
    };
  });
};

function flattenHierarchy(data) {
  let result = [];

  function traverse(node) {
    result.push({
      id: node.id,
      order: node.order,
      parent_id: node.parent_id,
    });
    if (node.children) {
      node.children.forEach(traverse);
    }
  }

  data.forEach(traverse);
  return result;
}

const SectionsTree = ({ sections, onSave }) => {
  const { t } = useTranslation();
  const [treeData, setTreeData] = useState(copyObject(sections));

  useEffect(() => {
    setTreeData(copyObject(sections));
  }, [sections]);

  const onDrop = useOnTreeDrop(treeData, (data) => {
    setTreeData(data);
  });

  const handleSave = () => {
    const simpleData = simplifyHierarchy(treeData);
    const flattedData = flattenHierarchy(simpleData);

    onSave(flattedData);
  };

  return (
    <div>
      <CollapseBlock>
        <Tree
          className="draggable-tree"
          draggable
          blockNode
          showLine
          onDrop={onDrop}
          treeData={treeData}
          titleRender={(node) => (
            <SortItemRenderer key={node.id} title={node.title} />
          )}
        />
      </CollapseBlock>
      <FormButtonsContainer>
        <SubmitButton onClick={handleSave} type="button">
          {t('Uložiť poradie')}
        </SubmitButton>
      </FormButtonsContainer>
    </div>
  );
};

SectionsTree.defaultProps = {
  sections: [],
};

export default SectionsTree;
